module.exports = __webpack_public_path__ + "img/cc.3ece0b82.png";